import { GrfqBbo } from '#/unified-rfqs/entities/grfq/bbo';
import {
  bestQuoteView,
  BestQuoteView,
} from '#/unified-rfqs/ui/rfqs/quotes-functions';
import { GrfqLeg } from '#/unified-rfqs/entities/grfq/domain';

export interface BestAskBidQuoteView {
  readonly ask: BestQuoteView;
  readonly bid: BestQuoteView;
}

export default function bestAskBidQuoteView(
  bbo: GrfqBbo | null,
  legs: readonly GrfqLeg[] | undefined,
): BestAskBidQuoteView {
  return {
    ask: bestQuoteView('SELL', bbo, legs),
    bid: bestQuoteView('BUY', bbo, legs),
  };
}
